import "./i18n";
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "./queries/queryClient";
import { AuthProvider } from "./contexts/AuthContext";
import { ToastProvider } from "./contexts/ToastContext";
import { ThemeProvider } from "./contexts/ThemeContext";
import { AppearanceProvider } from "./contexts/AppearanceContext";
import { ImpersonationProvider } from "./contexts/ImpersonationContext";
import App from "./App";
import "./fonts";
import "./index.css";
import "./styles/appearance.css";

// Sentry is intentionally DISABLED (2026-06-30). It is not currently used, and
// its frontend Session Replay recorded user sessions on errors — a data flow we
// do not want and do not disclose. To re-enable later, restore the DSN-gated
// Sentry.init() here (without replaysOnErrorSampleRate unless replay is
// reviewed) and add Sentry back to the Subprocessors page.

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <ThemeProvider>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <ToastProvider>
            <AuthProvider>
              <AppearanceProvider>
                <ImpersonationProvider>
                  <App />
                </ImpersonationProvider>
              </AppearanceProvider>
            </AuthProvider>
          </ToastProvider>
        </BrowserRouter>
      </QueryClientProvider>
    </ThemeProvider>
  </React.StrictMode>
);
